export const TEMPLATE_ENTITY_REF_KINDS = ['product', 'promotion', 'salesOrder', 'sysUser'];
//# sourceMappingURL=template-entity-ref-kinds.js.map